import moment from "moment";
import { apiClient } from '@repo/shared';

const initialiseNewEvent = () => {
  return {
    id: null,
    title: "",
    teacher: "",
    location: "",
    createdAt: "",
    updatedAt: "",
    active: true,
  };
}

const getAll = async () => {
  const events = await apiClient.get("/api/events");

  events?.sort((a,b) => {
    return moment(b.fromDate).format('X')-moment(a.fromDate).format('X')
  });
  return events;
};

const get = async (id) => {
  console.log('In classservice.get for id', id);
  const events = await apiClient.get(`/api/events/${id}`);
  const event = events?.[0];
  event.dates = event.dates.map(d => new Date(Date.parse(d)));
  return event;
};

const prepForSaving = (event, studentsForEvent) => {
  event.studentIds = studentsForEvent.map(s => s.id);
  event.dates = event.dates.map(cd => new Date(cd));
}

const create = async (event, studentsForEvent) => {
  prepForSaving(event, studentsForEvent);
  return await apiClient.post(`/api/events`, event);
};

const update = async (id, event, studentsForEvent) => {
  prepForSaving(event, studentsForEvent);
  return await apiClient.post(`/api/events/${id}`, event);
};

const remove = async (id) => {
  const events = await apiClient.delete(`/api/events/${id}`);
  return events;
};

const saveNotes = async(id, notes) => {
  return await apiClient.post(`/api/events/${id}/notes`, {notes});
};

const getEmailBody = async (id) => {
  const emailBody = await apiClient.get(`/api/events/${id}/email`);
  console.log(emailBody);
  return emailBody;
};

const EventService = {
  getAll,
  get,
  create,
  update,
  remove,
  initialiseNewEvent,
  saveNotes,
  getEmailBody
};

export default EventService;